import { SignalStoreBuilder } from "src/app/_stores/SignalStoreBuilder";
import { LocationData } from "src/app/_models/location/LocationData";
import { LocationDataDto } from "src/app/_models/location/LocationDTO";

type FreestandingBatteryDataMap = { id_location: number; data: LocationData[] };

export const SignalFreestandingBatteryDataStore =
  new SignalStoreBuilder<FreestandingBatteryDataMap>(
    (entry) => entry.id_location,
    (json) => {
      const id = json["id_location"] as number;
      const data = (json["data"] as unknown[]).map((d) =>
        LocationData.fromDto(LocationDataDto.fromJson(d)),
      );
      return { id_location: id, data };
    },
  )
    .withMethod(
      "loadData",
      (_store, http, { upsert }) =>
        async (id_location: number, limit: number = 120) => {
          const response = await http.get(
            `location/batteries/${id_location}/data?limit=${limit}`,
            { hideLoader: true },
          );
          if (!response) return;
          const data = (response["data"] as unknown[]).map((d) =>
            LocationData.fromDto(LocationDataDto.fromJson(d)),
          );
          upsert({ id_location, data });
        },
    )
    .withMethod(
      "loadLatest",
      (_store, http, { upsert }) =>
        async (id_location: number) => {
          const response = await http.get(
            `location/batteries/${id_location}/data?limit=1`,
            { hideLoader: true },
          );
          if (!response) return;
          const data = (response["data"] as unknown[]).map((d) =>
            LocationData.fromDto(LocationDataDto.fromJson(d)),
          );
          upsert({ id_location, data });
        },
    )
    .withAutoRefresh(
      async (store) => {
        for (const id of store.ids()) {
          await store.loadData(id as number);
        }
      },
      30_000,
    )
    .providedInRoot()
    .build();
